@import 'styles/mixins';
@import 'styles/variables';

.mergeIcon {
  color: var(--positive-50);
}

.excludeIcon {
  color: var(--negative-50);
}

.excludedHighlighter {
  border: 1px solid var(--neutral-10);
  background: var(--white);
}

.mergeHighlighter {
  border: 1px solid var(--neutral-10);
  background: var(--white);
}

.button {
  height: 28px;
}

.highlighter {
  height: 28px;
}
